import React from "react";

export interface CommonTextProps extends React.HTMLAttributes<HTMLElement> {
  as?: "p" | "span" | "div" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  size?: "xs" | "sm" | "base" | "lg" | "xl" | "xl2";
  level?: 1 | 2 | 3 | 4 | 5 | 6; // For headings
  className?: string;
  children: React.ReactNode;
}

const sizeMap = {
  xs: "text-xs",
  sm: "text-sm",
  base: "text-base",
  lg: "text-lg",
  xl: "text-xl",
  xl2: "text-2xl",
  xl3: "text-3xl",
  xl4: "text-4xl",
  xl5: "text-5xl",
  xl6: "text-6xl",

};

const defaultColor = "text-black";
const defaultHeadingColor = "text-black";

const CommonText: React.FC<CommonTextProps> = ({
  as = "p",
  size = "base",
  level,
  className,
  children,
  ...props
}) => {
  let Tag = typeof as === 'string' ? as : 'p';
  if (level && [1,2,3,4,5,6].includes(level)) {
    Tag = `h${level}`;
  }
  const hasTextColor = typeof className === 'string' && className.split(' ').some(cls => cls.startsWith('text-'));
  const colorClass = hasTextColor ? "" : (Tag.startsWith("h") ? defaultHeadingColor : defaultColor);
  const sizeClass = sizeMap[size] || "";
  const classes = [colorClass, sizeClass, className].filter(Boolean).join(" ").trim();
  return (
    <Tag className={classes} {...props}>
      {children}
    </Tag>
  );
};

export default CommonText; 